import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setMeta } from '../utils/seo';
import { SeoBreadcrumbs, SeoRelatedLinks } from '../components/SeoPageBlocks';
import guidesContent from '../data/guidesContent';

const PUBLISHED_DATE = '2026-04-25';
const UPDATED_DATE = '2026-04-25';

const relatedLinks = [
  { to: '/guide', text: '扑克攻略中心' },
  { to: '/guide/omaha', text: '奥马哈Omaha竞技详解' },
  { to: '/guide/position-strategy', text: '德州扑克位置策略进阶攻略' },
  { to: '/download', text: 'HHpoker下载' }
];

function TxPokerCompleteGuide() {
  useEffect(() => {
    setMeta({
      title: '德州扑克完整规则教程_新手快速入门指南',
      description: '德州扑克新手入门完整教程，从游戏流程、牌型大小到起手牌策略，系统学习HHpoker竞技扑克规则，快速从零掌握德扑基础。',
      keywords: '德州扑克规则, 德州扑克入门, Texas Hold\'em规则, 德扑牌型大小, 德扑起手牌策略, HHpoker竞技扑克, 德扑游戏流程',
      url: window.location.origin + '/texas-poker-complete-guide/',
      robots: 'index,follow',
      image: window.location.origin + '/images/banner.jpg',
      jsonLd: {
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'Article',
            headline: '德州扑克完整规则教程_新手快速入门指南',
            description: '德州扑克新手入门完整教程，系统讲解游戏流程、牌型大小、起手牌策略和资金管理。',
            datePublished: PUBLISHED_DATE,
            dateModified: UPDATED_DATE,
            author: { '@type': 'Organization', name: 'HHpoker攻略' }
          },
          {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: window.location.origin + '/' },
              { '@type': 'ListItem', position: 2, name: '扑克攻略', item: window.location.origin + '/guide/' },
              { '@type': 'ListItem', position: 3, name: '德州扑克完整规则教程' }
            ]
          }
        ]
      }
    });
  }, []);

  const content = (guidesContent['竞技扑克新手入门规则'] || []).join('');

  return (
    <div style={{ background: '#1a1c29', color: '#fff', minHeight: '100vh', padding: '80px 20px' }}>
      <div style={{ maxWidth: '920px', margin: '0 auto', lineHeight: 1.8 }}>
        <SeoBreadcrumbs currentLabel="德州扑克完整规则教程" />
        <h1 style={{ color: '#efa765', fontSize: '2rem' }}>德州扑克完整规则教程：新手快速入门指南</h1>
        <p style={{ color: '#a9afbc', fontSize: '0.9rem' }}>发布时间：{PUBLISHED_DATE} ｜ 更新时间：{UPDATED_DATE}</p>
        <p>本教程面向零基础新手，系统讲解德州扑克（Texas Hold'em）完整规则，包括游戏流程、牌型大小、翻牌前策略及实战技巧，帮助你在HHpoker快速上手竞技扑克。</p>

        <div
          dangerouslySetInnerHTML={{ __html: content }}
          style={{ lineHeight: 1.9 }}
        />

        <h2>进一步学习</h2>
        <p>掌握基础规则后，推荐系统学习以下进阶内容：</p>
        <ul>
          <li><Link to="/guide/position-strategy" style={{ color: '#efa765' }}>位置策略：前位/后位如何影响盈利</Link></li>
          <li><Link to="/guide/bankroll-management" style={{ color: '#efa765' }}>资金管理：长期稳健盈利必修课</Link></li>
          <li><Link to="/guide/omaha" style={{ color: '#efa765' }}>奥马哈玩法与德州扑克的核心差异</Link></li>
        </ul>

        <SeoRelatedLinks links={relatedLinks} />
      </div>
    </div>
  );
}

export default TxPokerCompleteGuide;
